import { IKnmErknmFormAct } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormAct';
import { IKnmErknmFormResultDecision } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormResultDecision';

import { IKnmFormRef } from '../interfaces/IKnmFormRef';

interface IRemoveSubjectLinkedActsAndDecisionsParams {
  formRef: IKnmFormRef | undefined;
  listId: string | undefined;
}

export const removeSubjectLinkedActsAndDecisions = ({
  formRef,
  listId,
}: IRemoveSubjectLinkedActsAndDecisionsParams): boolean => {
  const remove = formRef?.current.mutators.remove;

  if (!formRef || !remove || !listId) {
    return false;
  }

  const collectIndicesToRemove = (items: { organization?: { listId?: string } | undefined }[]): number[] => {
    const indices: number[] = [];

    items.forEach((item, index) => {
      if (item?.organization?.listId === listId) {
        indices.push(index);
      }
    });

    return indices.reverse();
  };

  const acts: IKnmErknmFormAct[] = formRef.current?.getFieldState('acts')?.value || [];
  const resultDecisions: IKnmErknmFormResultDecision[] = formRef.current?.getFieldState('resultDecisions')?.value || [];

  const actIndices = collectIndicesToRemove(acts);
  const decisionIndices = collectIndicesToRemove(resultDecisions);

  actIndices.forEach(index => remove('acts', index));
  decisionIndices.forEach(index => remove('resultDecisions', index));

  return actIndices.length > 0 || decisionIndices.length > 0;
};
